import { useQuery } from '@tanstack/react-query';
import { fromTable } from '@/integrations/supabase/db';
import type { Tables } from '@/integrations/supabase/types';

type Gesellschaft = Tables<'gesellschaften'>;

interface UseGesellschaftenOptions {
  select?: 'basic' | 'extended' | 'full';
  filterByStatus?: string[];
  filterByNames?: string[];
  enabled?: boolean;
}

export function useGesellschaften(options?: UseGesellschaftenOptions) {
  const { select = 'basic', filterByStatus, filterByNames, enabled = true } = options || {};

  return useQuery({
    queryKey: ['gesellschaften', select, filterByStatus, filterByNames],
    queryFn: async () => {
      let query = fromTable('gesellschaften').select(
        select === 'basic' 
          ? 'id, name'
          : select === 'extended'
          ? 'id, name, status, bereich, logo_url, auskunftsvollmachtmail'
          : '*'
      );

      if (filterByStatus && filterByStatus.length > 0) {
        query = query.in('status', filterByStatus);
      }

      if (filterByNames && filterByNames.length > 0) {
        query = query.in('name', filterByNames);
      }

      query = query.order('name');

      const { data, error } = await query;

      if (error) throw error;
      return data as any;
    },
    staleTime: 10 * 60 * 1000, // 10 minutes - semi-statische Stammdaten
    gcTime: 20 * 60 * 1000, // 20 minutes
    enabled,
  });
}
